<template>
    <div>
        <b-card>
            <div slot="header" style="margin-top:-7px;margin-bottom:-12px">Lönespecifikationer för <span v-if="!loginState.isAuditor">{{loginState.user.firstName}} {{loginState.user.lastName}}</span>
                <UserDropdown class="mb-1" :selectedUserId=selectedUserId @onUserSelected="userSelected" v-if="loginState.isAdministrator" employeeOnly="true"/>
                <b-button variant="primary" class="btn btn-primary ml-1 " style="height:34px;margin-bottom:4px" 
                    v-on:click="addSalarySpecification()" v-if="loginState.isAdministrator">
                    <i class="fa fa-plus"/>&nbsp;Skapa lönespecifikation
                </b-button>
                <div class="card-header-actions" v-if="loading">
                    <b-spinner class="mr-1" type="border" small />
                </div>
            </div>
            
            <SpecificationsTable :salarySpecifications="salarySpecifications" @onLoading="onLoading" @onSalarySpecificationSelected="onSalarySpecificationSelected"/>
        </b-card>
        <CreateSalarySpecificationDialog ref="createSalarySpecificationDialog" :employee="selectedUser"/>
    </div>
</template>

<script>
import { salarySpecificationService } from "../../../shared/services";
import SpecificationsTable from "./SpecificationsTable"
import CreateSalarySpecificationDialog from './CreateSalarySpecificationDialog'
import UserDropdown from "../../components/UsersDropdown"

export default {
    components: {
        UserDropdown,
        SpecificationsTable,
        CreateSalarySpecificationDialog
    },
    methods: {
        getSalarySpecificationsByUser(userId) {
            salarySpecificationService.getByUser(userId).then(p => {
            this.salarySpecifications = p;
            }).catch(() => window.toastr.error("Ett okänt fel uppstod då peronliga lönespecifikationer hämtas"));
        },  
        onLoading(loading) {
            this.loading = loading;
        },
        userSelected(user) {
            this.$router.push({ path: `salaryspecifications?userId=${user.id}` });
        },
        onSalarySpecificationSelected(salarySpecification) {
            this.$router.push({ path: `salaryspecifications/${salarySpecification.id}` });
        },
        addSalarySpecification() {
            this.$refs.createSalarySpecificationDialog.show();
        }
    },
    data() {
        return {
            selectedUserId: 0,
            selectedUser: null,
            loading: false,
            salarySpecifications: []
        };
    },
    mounted() {
        this.selectedUser = this.loginState.user;
        this.selectedUserId = this.$route.query.userId ? parseInt(this.$route.query.userId) : this.loginState.user.id;
        this.getSalarySpecificationsByUser(this.selectedUserId);
    },
}
</script>

<style>

</style>
